__turbopack_context__.v({
  "badgeTop": "BentoEcosystem-module__Qtwvya__badgeTop",
  "card": "BentoEcosystem-module__Qtwvya__card",
  "cardBadge": "BentoEcosystem-module__Qtwvya__cardBadge",
  "cardBody": "BentoEcosystem-module__Qtwvya__cardBody",
  "cardDesc": "BentoEcosystem-module__Qtwvya__cardDesc",
  "cardFooter": "BentoEcosystem-module__Qtwvya__cardFooter",
  "cardHeader": "BentoEcosystem-module__Qtwvya__cardHeader",
  "cardLarge": "BentoEcosystem-module__Qtwvya__cardLarge",
  "cardLink": "BentoEcosystem-module__Qtwvya__cardLink",
  "cardMedium": "BentoEcosystem-module__Qtwvya__cardMedium",
  "cardTitle": "BentoEcosystem-module__Qtwvya__cardTitle",
  "container": "BentoEcosystem-module__Qtwvya__container",
  "grid": "BentoEcosystem-module__Qtwvya__grid",
  "header": "BentoEcosystem-module__Qtwvya__header",
  "highlightBadge": "BentoEcosystem-module__Qtwvya__highlightBadge",
  "iconCircle": "BentoEcosystem-module__Qtwvya__iconCircle",
  "section": "BentoEcosystem-module__Qtwvya__section",
  "subtitle": "BentoEcosystem-module__Qtwvya__subtitle",
  "tagPill": "BentoEcosystem-module__Qtwvya__tagPill",
  "title": "BentoEcosystem-module__Qtwvya__title",
  "titleHighlight": "BentoEcosystem-module__Qtwvya__titleHighlight",
});
